export const AD_BANNER_CLIENTSIDE_HOOK = 'retailMedia_slot'
export const AD_BANNER_CLOSE_CLIENTSIDE_HOOK = 'bannerClose'
export const AD_BANNER_LEGAL_BUTTON_CLIENTSIDE_HOOK = 'asLegalButton'
export const AD_BANNER_TOP_BANNER_DIMENSIONS = { width: 1920, height: 100 }
export const AD_BANNER_PARTNER_CODE_SEARCH_PARAM = 'partnercode'
export const AD_BANNER_STATUS_DATA_ATTR = 'data-as-status'
export const AD_BANNER_TAGS_DATA_ATTR = 'data-as-tags'
export const AD_BANNER_CONTENT_DATA_ATTR = 'data-as-content'
export const AD_BANNER_WIDTH_DATA_ATTR = 'data-as-width'
export const AD_BANNER_HEIGHT_DATA_ATTR = 'data-as-height'
export const AD_BANNER_AUTO_LOAD_DATA_ATTR = 'data-auto-load'
export const AD_BANNER_CAMPAIGN_NAME_DATA_ATTR = 'data-as-campaign-name'
// can be also used as a cookie name
export const AD_BANNER_TRIAD_CAMPAIGN_NAME = 'dreiklang0922'
export const AD_BANNER_STORAGE_KEY = 'ad_banner_flag'
export const AD_BANNER_FLIGHT_ID_DATA_ATTR = 'data-as-flight-id'
export const AD_BANNER_TOP_BANNER_DISPLAY_DATA_ATTR = 'data-as-top-banner'
export const AD_BANNER_LEGAL_BUTTON_TEXT_CLASS =
  'as-placeholder__legalButton-text'
export const AD_BANNER_LEGAL_BUTTON_LABEL_CLASS =
  'as-placeholder__legalButton-label'
